<template>
	<sf-data-table
		ref="grpTable"
		index
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
	>
		<template v-slot:customRows="slotProps">
			<template v-for="(item, index) in monthlabel">
				<template v-if="slotProps.column.property === item">
					<td
						:key="index"
						class="col-1"
						style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
					>
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcGrntCt/store/helpers';
import CarSale from '@mqy/qlty/CarSale/CarSale.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			monthlabel: '',
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {
		this.monthlabel = this.monthlabel_;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		async onGoClick(argsCnt, rowsInfo) {
			return false;
			let item = {
				name: this.getMessage_('QWCC001899'), //PMC 판매정보
				component: CarSale, //import할 컴포넌트 이름
				scrId: this.pmcSaleListScrId, //이동할 scr
				msgKey: 'O90000019' //R/O리스트
			};

			if (argsCnt > 0) {
				//날짜검색값
				const { carScn = '', pacScn = '', flclSpc = '' } = this.searchParams; //검색값
				const label = rowsInfo.column.labelClassName;
				const labelDt = this.$moment(label).format('YYYYMM');
				const today = this.$moment().format('DD');

				const pEndDt = this.$moment(labelDt + today).format('YYYYMMDD');
				const pStartDt = this.$moment(pEndDt).subtract(5, 'years').format('YYYYMMDD');
				const pState1 = carScn; // 차량구분
				const pState2 = pacScn; // 승상구분
				const pState3 = flclSpc; // 연료전지사양
				const pState4 = rowsInfo.row.saleRegn || ''; // 판매지역
				const pState5 = ''; // 보증만료일

				await this.getScreen_({ scrId: item.scrId });
				await this.$sf_removeTab(item.scrId);
				await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, pStartDt, pEndDt, pState1, pState2, pState3, pState4, pState5 });
			}
		}
	}
};
</script>

<style></style>
